import { useRoute, useRouter } from 'vue-router';

export const useSort = () => {
  const isHightPrice = ref(false);
  const route = useRoute();
  const router = useRouter();
  const { t } = useI18n();
  const isActiveSort: Ref<boolean> = ref(Boolean(route.query.ordering));

  const orderingType = computed(() => isHightPrice.value ? '-price' : 'price');

  const toggleSort = (): void => {
    isHightPrice.value = !isHightPrice.value;
    isActiveSort.value = true;
    router.push({ query: { ...route.query, ordering: orderingType.value } });
    refreshNuxtData('catalog-products');
  };

  const resetSort = (): void => {
    isActiveSort.value = false;
    router.push({ query: { ...route.query, ordering: undefined } });
    refreshNuxtData('catalog-products');
  };

  const sortButtonText: Ref<string> = computed(() =>
    isHightPrice.value ? t('expensiveFirst') : t('cheapFirst'),
  );

  return {
    isHightPrice,
    isActiveSort,
    toggleSort,
    resetSort,
    sortButtonText
  };
};
